import { Suspense, lazy } from 'react';

import { ErrorBoundary } from '@/_components';
import ErrorFallback from '@/_components/error/error-fallback';

import { Layout } from './layout';
import { Loading } from './loading';

const Page = lazy(() => import('./page'));

export function PaymentOptionsPage() {
  return (
    <Layout>
      <ErrorBoundary FallbackComponent={<ErrorFallback />}>
        <Suspense fallback={<Loading />}>
          <Page />
        </Suspense>
      </ErrorBoundary>
    </Layout>
  );
}
